/* eslint-disable @typescript-eslint/no-require-imports */
import fs from 'fs'
import path from 'path'

// ============================================================================
// JSDoc programmatic parser (adapted from JS-Code-Runner)
// ============================================================================

export interface DocletTag {
  originalTitle: string
  value?: string
  text?: string
}

interface DocletParam {
  name: string
  type?: { names?: string[] }
  optional?: boolean
  description?: string
}

interface DocletProperty {
  name: string
  type?: { names?: string[] }
  optional?: boolean
  description?: string
}

export interface Doclet {
  kind: string
  name: string
  memberof?: string
  scope?: string
  description?: string
  tags?: DocletTag[]
  params?: DocletParam[]
  properties?: DocletProperty[]
  returns?: { type?: { names?: string[] } }[]
  access?: string
}

function resolveJSDocPath(): string {
  const jsDocHolders = require.resolve.paths('jsdoc/lib') || []
  const jsDocPaths = jsDocHolders.map((p: string) => path.join(p, 'jsdoc/lib'))

  for (let i = 0; i < jsDocPaths.length; i++) {
    if (fs.existsSync(jsDocPaths[i])) {
      return jsDocPaths[i]
    }
  }

  throw new Error('Can not resolve path to JSDoc module.')
}

const jsdocPath = resolveJSDocPath()
const jsdocModulePath = (mod: string) => path.join(jsdocPath, ...mod.split('/'))

let _jsdocRequire: NodeRequire

const jsdocRequire = (modulePath: string) => {
  if (!_jsdocRequire) {
    _jsdocRequire = require('requizzle')({
      infect: true,
      requirePaths: { before: [jsdocPath] },
    })

    const Config = _jsdocRequire(jsdocModulePath('jsdoc/config'))
    const env = _jsdocRequire(jsdocModulePath('jsdoc/env'))
    env.conf = new Config().get()
  }

  return _jsdocRequire(jsdocModulePath(modulePath))
}

/**
 * Parse a JS file using jsdoc programmatically and return the doclets array.
 */
export function parseJSDoc(filePath: string): Doclet[] {
  const parser = jsdocRequire('jsdoc/src/parser').createParser()
  const handlers = jsdocRequire('jsdoc/src/handlers')

  handlers.attachTo(parser)

  return parser.parse([filePath])
}
